import React, { useState } from 'react';
import axios from 'axios';
import DoubleHappiness from './DoubleHappiness';
import { preparePasswordForTransmission } from '../utils/passwordEncoder';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // 使用工具函数准备密码传输
      const passwordData = preparePasswordForTransmission(password);
      
      const response = await axios.post('/api/admin/login', passwordData);

      if (response.data.success) {
        // 存储JWT token
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminLoginTime', Date.now().toString());
        
        onLogin(true);
      }
    } catch (error) {
      console.error('Login error:', error);
      
      if (error.response && error.response.data) {
        setError(error.response.data.error || '登录失败，请重试');
      } else {
        setError('网络错误，请检查连接后重试');
      }
      
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-red-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-chinese-red to-chinese-pink p-8 text-center">
            <DoubleHappiness size={80} color="white" />
            <h1 className="text-3xl font-chinese font-bold text-white mt-4">
              管理员登录
            </h1>
            <p className="text-white/90 mt-2">
              Admin Login - Wedding RSVP Management
            </p>
          </div>

          {/* Login Form */}
          <div className="p-8">
            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  管理密码 Admin Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-chinese-red focus:border-transparent transition-all ${
                    error ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="请输入管理密码"
                  disabled={loading}
                />
                {error && (
                  <p className="mt-2 text-sm text-red-600">
                    ❌ {error}
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={loading || !password}
                className={`w-full py-3 px-4 rounded-lg font-chinese font-bold text-white transition-all transform hover:scale-105 ${
                  loading || !password
                    ? 'bg-gray-400 cursor-not-allowed transform-none'
                    : 'bg-gradient-to-r from-chinese-red to-chinese-pink hover:shadow-lg'
                }`}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    验证中...
                  </span>
                ) : (
                  <>
                    <span className="mr-2">🔐</span>
                    登录管理后台
                  </>
                )}
              </button>
            </form>

            {/* Info */}
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <h4 className="text-sm font-bold text-gray-700 mb-2">🔒 安全提示</h4>
              <ul className="text-xs text-gray-600 space-y-1">
                <li>• 密码使用Base64编码传输，增强安全性</li>
                <li>• 使用后端JWT令牌验证，更加安全</li>
                <li>• 登录状态24小时后自动过期</li>
                <li>• 所有管理API都受到保护</li>
                <li>• 请勿在公共设备上登录</li>
              </ul>
            </div>

            {/* Back to Home */}
            <div className="mt-6 text-center">
              <a
                href="/"
                className="text-chinese-red hover:text-chinese-dark transition-colors text-sm"
              >
                ← 返回婚礼主页
              </a>
            </div>
          </div>
        </div>

        {/* Default Password Info - 仅开发环境显示 */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-4 p-4 bg-yellow-100 border border-yellow-400 rounded-lg text-center">
            <p className="text-sm text-yellow-800">
              <strong>开发环境提示：</strong>默认密码是 <code className="bg-yellow-200 px-1 rounded">hanshans2025</code>
            </p>
            <p className="text-xs text-yellow-700 mt-1">
              生产环境请通过环境变量 ADMIN_PASSWORD 设置密码
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
